import createSelectors from './createSelectors';
import PatientRecord from '../models/PatientRecord';

const Select = createSelectors(PatientRecord, {});

export default Select;
